import React from 'react';
import { CotizacionesState, CotizacionData } from '../../types/cotizaciones';
import { CotizacionesList } from './CotizacionesList';
import {
  XMarkIcon,
  XCircleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

interface CotizacionesModalProps {
  isOpen: boolean;
  onClose: () => void;
  cotizaciones: CotizacionesState;
  todasLasCotizaciones: CotizacionData[];
  onSelectCotizacion: (cotizacion: CotizacionData) => void;
  loading?: boolean;
}

export const CotizacionesModal: React.FC<CotizacionesModalProps> = ({
  isOpen,
  onClose,
  cotizaciones,
  todasLasCotizaciones,
  onSelectCotizacion,
  loading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg shadow-xl p-8 m-4 max-w-5xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className=" ">
              {loading ? 'Obteniendo Cotizaciones' : 'Cotizaciones Disponibles'}
            </h2>
{/*             <p className="text-gray-600 mt-1">
              {loading 
                ? 'Consultando transportadoras...' 
                : `Se encontraron ${todasLasCotizaciones.length} opciones de envío`
              }
            </p> */}
          </div>
          {!loading && (
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors">
                <XMarkIcon className="w-6 h-6" />
            </button>
          )}
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-16">
            <div className="animate-spin rounded-full h-20 w-20 border-b-2 border-blue-800 mb-6"></div>
            <div className="text-center">
              <p className="text-gray-700 text-xl font-semibold mb-2">Obteniendo cotizaciones...</p>
              <p className="text-gray-500 text-base mb-6">Consultando múltiples transportadoras</p>
              
              {/* Lista de transportadoras consultando */}
              <div className="bg-gray-50 rounded-lg p-4 mb-4 max-w-md">
                <p className="text-sm font-medium text-gray-700 mb-3">Consultando:</p>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Envía</span>
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
                      <span className="text-xs text-gray-500">Consultando...</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">99 Minutos</span>
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
                      <span className="text-xs text-gray-500">Consultando...</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Inter Rapidisimo</span>
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
                      <span className="text-xs text-gray-500">Consultando...</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Deprisa</span>
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
                      <span className="text-xs text-gray-500">Consultando...</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">Coordinadora</span>
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
                      <span className="text-xs text-gray-500">Consultando...</span>
                    </div>
                  </div>
                </div>
              </div>
              
{/*               <div className="flex justify-center space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
              </div> */}
            </div>
          </div>
        ) : cotizaciones.error && todasLasCotizaciones.length === 0 ? (
          <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <XCircleIcon className="h-5 w-5 text-red-400" />
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  <strong>Error:</strong> {cotizaciones.error}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {/* Mostrar información sobre transportadoras disponibles */}
            {todasLasCotizaciones.length > 0 && (
              <div className="mb-6">
                <div className="bg-green-50 border-l-4 border-green-400 p-4 mb-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon className="h-5 w-5 text-green-400" />
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-green-700">
                        <strong>Cotizaciones disponibles:</strong> Se encontraron {todasLasCotizaciones.length} opciones de envío
                      </p>
                    </div>
                  </div>
                </div>
                
                {/* Mostrar información sobre transportadoras no disponibles (solo como info) */}
                {(() => {
                  const carriersDisponibles = Array.from(new Set(todasLasCotizaciones.map(c => c.carrier)));
                  const carriersNoDisponibles = [];
                  
                  if (!carriersDisponibles.includes('Envía') && cotizaciones.envia && !cotizaciones.envia.success) {
                    carriersNoDisponibles.push({ name: 'Envía', reason: cotizaciones.envia.data?.respuesta || 'Sin cobertura' });
                  }
                  if (!carriersDisponibles.includes('Noventa9Minutos') && cotizaciones.noventa9Minutos && !cotizaciones.noventa9Minutos.success) {
                    carriersNoDisponibles.push({ name: '99 Minutos', reason: 'Sin cotizaciones' });
                  }
                  if (!carriersDisponibles.includes('InterRapidisimo') && cotizaciones.interRapidisimo && !cotizaciones.interRapidisimo.success) {
                    carriersNoDisponibles.push({ name: 'InterRapidisimo', reason: 'Sin cotizaciones' });
                  }
                  if (!carriersDisponibles.includes('deprisa') && cotizaciones.deprisa && !cotizaciones.deprisa.success) {
                    carriersNoDisponibles.push({ name: 'Deprisa', reason: 'Sin cotizaciones' });
                  }
                  if (!carriersDisponibles.includes('Coordinadora') && cotizaciones.coordinadora && !cotizaciones.coordinadora.success) {
                    carriersNoDisponibles.push({ name: 'Coordinadora', reason: 'Sin cotizaciones' });
                  }
                  
                  return carriersNoDisponibles.length > 0 ? (
                    <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                      <div className="flex">
                        <div className="flex-shrink-0">
                          <InformationCircleIcon className="h-5 w-5 text-blue-400" />
                        </div>
                        <div className="ml-3">
                          <p className="text-sm text-blue-700">
                            <strong>Información adicional:</strong> Algunas transportadoras no están disponibles para esta ubicación
                          </p>
                          <ul className="mt-2 text-xs text-blue-600 list-disc list-inside">
                            {carriersNoDisponibles.map((carrier, index) => (
                              <li key={index}>{carrier.name}: {carrier.reason}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ) : null;
                })()}
              </div>
            )}
            
            <CotizacionesList 
              cotizaciones={todasLasCotizaciones}
              onSelect={onSelectCotizacion}
            />
          </div>
        )}

        {!loading && (
          <div className="flex justify-end space-x-4 mt-8 pt-6 border-t border-gray-200">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
